import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { useSiteConfig } from "../lib/site";

export default function Footer() {
  const config = useSiteConfig();
  const b = config.business;

  return (
    <footer className="bg-primary text-primary-foreground" data-testid="site-footer">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 px-6 py-8 text-sm md:flex-row md:items-center md:justify-between">
        <div>
          <p className="font-serif text-xl font-semibold tracking-tight">
            Dorothy Read <span className="ml-1 align-middle text-[0.6rem] font-semibold uppercase tracking-[0.35em] text-secondary">Healing</span>
          </p>
          <a
            href={b.maps_url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-directions-link"
            className="mt-1 inline-flex items-center gap-1.5 text-xs text-primary-foreground/80 underline-offset-4 transition-colors duration-200 hover:text-primary-foreground hover:underline"
          >
            <MapPin size={12} aria-hidden /> {b.address_lines.join(", ")}
          </a>
        </div>

        <nav aria-label="Footer navigation">
          <ul className="flex flex-wrap gap-x-4 gap-y-1 text-xs">
            <li><Link className="underline-offset-4 hover:underline" to="/services">Services & Rates</Link></li>
            <li><Link className="underline-offset-4 hover:underline" to="/about">About</Link></li>
            <li><Link className="underline-offset-4 hover:underline" to="/contact">Contact</Link></li>
            <li><Link className="underline-offset-4 hover:underline" data-testid="footer-privacy-link" to="/privacy">Privacy</Link></li>
          </ul>
        </nav>
      </div>

      <div className="border-t border-primary-foreground/15">
        <p className="mx-auto max-w-6xl px-6 py-4 text-xs leading-relaxed text-primary-foreground/60">
          {config.disclaimer} &copy; {new Date().getFullYear()} {b.name}.
        </p>
      </div>
    </footer>
  );
}
